import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { WalletRecordMapped } from '@tassat/fred-extended-definitions';
import React from 'react';

import { formatEpochDate } from 'Lib/stringHelpers';

interface LastTransactionDateCellRendererProps {
    value: WalletRecordMapped;
    align?: 'center' | 'flex-start' | 'flex-end';
}

const muiStyles = makeStyles({
    root: {
        whiteSpace: 'normal' as const,
        alignSelf: (props: LastTransactionDateCellRendererProps) => props.align || undefined
    },
    date: { lineHeight: '18px' }
});

const LastTransactionDateCellRenderer = (props: LastTransactionDateCellRendererProps) => {
    const { value } = props;

    const {
        root,
        date
    } = muiStyles(props);

    if (!value) return <></>;

    const lastTransactionTime = value.walletStats?.reduce((acc, cv) => {
        const stat = Number(cv.LastTransactionTime);
        if (stat > acc) {
            return stat;
        }

        return acc;
    }, 0);

    return (
        <Grid
            className={root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            {!lastTransactionTime && lastTransactionTime === 0 ?
                <span data-testid='last-transaction-date'>-</span>
                : (
                    <>
                        <span
                            className={date}
                            data-testid='last-transaction-date'
                        >{formatEpochDate(lastTransactionTime, 'MMM DD YYYY')}
                        </span>
                        <span
                            className={date}
                            data-testid='last-transaction-time'
                        >{formatEpochDate(lastTransactionTime, 'HH:mm:ss')}
                        </span>
                    </>
                )}
        </Grid>
    );
};

export default LastTransactionDateCellRenderer;

// ({ value }): string => formatEpochDate(value) || '-',